import { createWithEqualityFn } from 'zustand/traditional';
import { persist, createJSONStorage } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';

const btn_tab_1 = [
  {
    label: 'Сотрудники',
    value: 'employee',
  },
  {
    label: 'Подключения',
    value: 'settings',
  },
  {
    label: 'Роли',
    value: 'roles',
  }
];

export const useGeneralStore = createWithEqualityFn(
  persist(
    (set) => ({
      // Модалка - уведомления об ошибках
      isModalNotificationsError: false,
      setIsModalNotificationsError: (value) => set({ isModalNotificationsError: value }),

      currentFilterService: false,
      setCurrentFilterService: (value) => set({ currentFilterService: value }),

      counterError: false,
      setCounterError: (value) => set({ counterError: value }),

      // Пространства
      isAuthorSpase: false,
      setIsAuthorSpase: (value) => set({ isAuthorSpase: value }),

      spaceList: [],
      setSpaceList: (list) => set({ spaceList: list }),

      currentSpace: {},
      setCurrentSpace: (space) => set({ currentSpace: space }),

      selectedSpace: {},
      setSelectedSpace: (value) => set({ selectedSpace: value }),

      pageValue1: btn_tab_1[0].value,
      setPageValue1: (value) => set({ pageValue1: value }),

      isModalAddEmployees: false,
      setIsModalAddEmployees: (value) => set({ isModalAddEmployees: value }),

      isModalRole: false,
      setIsModalRole: (value) => set({ isModalRole: value }),

      // Уведомления общий чат
      chatListNotification: {},
      setChatListNotification: (count) => set({ chatListNotification: count }),

      unreadCountCommon: 0,
      setUnreadCountCommon: (val) => set({ unreadCountCommon: val }),

      unreadCountPersonal: 0,
      setUnreadCountPersonal: (val) => set({ unreadCountPersonal: val }),

      unreadCountGroup: 0,
      setUnreadCountGroup: (val) => set({ unreadCountGroup: val }),

      userStatus: [],
      setUserStatus: (val) => set({ userStatus: val }),

      // Уведомления
      notificationCounter: 0,
      setNotificationCounter: (value) => set({ notificationCounter: value }),

      isChangeNotification: false,
      setIsChangeNotification: (value) => set({ isChangeNotification: value }),

      // Уведомление snackBarMui
      isOpenSnackbar: false,
      setIsOpenSnackbar: (value) => set({ isOpenSnackbar: value }),

      contentSnackbar: '',
      setContentSnackbar: (value) => set({ contentSnackbar: value }),

      // Тариф
      statusTariff: false,
      setStatusTariff: (value) => set({ statusTariff: value }),

      tariffInSpace: [],
      setTariffInSpace: (value) => set({ tariffInSpace: value }),

      isPending: false,
      setisPending: (value) => set({ isPending: value }),

      // Баланс
      balance: 0,
      setBalance: (value) => set({ balance: value }),

      accounList: [],
      setAccountList: (list) => set({ accounList: list }),

      employeesList: [],
      setEmployeesList: (list) => set({ employeesList: list }),

      availableEmployeesList: [],
      setAvailableEmployeesList: (list) => set({ availableEmployeesList: list }),

      // Модальные окна для контактов и компаний
      currentDeal: null,
      setCurrentDeal: (deal) => set({ currentDeal: deal }),

      currentCompany: null,
      setCurrentCompany: (company) => set({ currentCompany: company }),

      currentContact: null,
      setCurrentContact: (contact) => set({ currentContact: contact }),

      currentContract: null,
      setCurrentContract: (contract) => set({ currentContract: contract }),

      currentServices: null,
      setCurrentServices: (services) => set({ currentServices: services }),

      isModalCompany: false,
      setIsModalCompany: (isModal) => set({ isModalCompany: isModal }),

      isModalContact: false,
      setIsModalContact: (isModal) => set({ isModalContact: isModal }),

      isModalContract: false,
      setIsModalContract: (isModal) => set({ isModalContract: isModal }),

      isModalServices: false,
      setIsModalServices: (isModal) => set({ isModalServices: isModal }),
    }),
    {
      name: 'general-storage',
      // storage: createJSONStorage(() => localStorage) // раскомментируйте если нужно
    }
  ),
  shallow // функция сравнения по умолчанию
);

export default useGeneralStore;